var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWalkingBehavior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "696px",
    height: "800px",
    viewBox: "0 0 696 800",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    stroke: "#3BB1E6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 26,
    fill: "#000000",
    strokeLinejoin: "round",
    transform: "translate(131.500000, 134.000000) rotate(-45.000000) translate(-131.500000, -134.000000) ",
    x: 131,
    y: -5,
    width: 1,
    height: 278
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 26,
    fill: "#000000",
    strokeLinejoin: "round",
    transform: "translate(561.500000, 134.000000) scale(-1, 1) rotate(-45.000000) translate(-561.500000, -134.000000) ",
    x: 561,
    y: -5,
    width: 1,
    height: 278
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 26,
    fill: "#000000",
    strokeLinejoin: "round",
    transform: "translate(108.500000, 587.000000) scale(-1, 1) rotate(-45.000000) translate(-108.500000, -587.000000) ",
    x: 108,
    y: 483,
    width: 1,
    height: 208
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 26,
    fill: "#000000",
    strokeLinejoin: "round",
    transform: "translate(583.500000, 588.000000) rotate(-45.000000) translate(-583.500000, -588.000000) ",
    x: 583,
    y: 484,
    width: 1,
    height: 208
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346,88.5 C371.857211,88.5 394.550597,102.037495 407.387365,122.407046 C408.081541,123.508573 408.745256,124.627483 409.383911,125.763321 C410.691697,126.12366 411.997593,126.496002 413.301442,126.880382 C461.632379,141.12853 503.352213,170.796107 532.778244,210.181608 C561.498008,248.6218 578.5,296.325747 578.5,348 C578.5,411.650817 552.700409,469.275817 510.988113,510.988113 C469.275817,552.700409 411.650817,578.5 348,578.5 C284.349183,578.5 226.724183,552.700409 185.011887,510.988113 C143.299591,469.275817 117.5,411.650817 117.5,348 C117.5,297.215517 133.921316,250.265709 161.748682,212.175192 C190.299302,173.094675 230.848982,143.333272 277.981458,128.324077 C279.278867,127.910921 280.57867,127.509769 281.880513,127.117276 C282.487803,125.971562 283.126349,124.840978 283.795715,123.726944 C296.4742,102.62598 319.586417,88.5 346,88.5 Z",
    id: "Combined-Shape",
    strokeWidth: 21
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 23,
    cx: 348,
    cy: 348,
    r: 336.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 24,
    fill: "#000000",
    strokeLinejoin: "round",
    x: 346,
    y: 548,
    width: 1,
    height: 238
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 24,
    fill: "#000000",
    strokeLinejoin: "round",
    x: 256,
    y: 468,
    width: 1,
    height: 318
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 24,
    fill: "#000000",
    strokeLinejoin: "round",
    x: 436,
    y: 468,
    width: 1,
    height: 318
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    strokeWidth: 24,
    fill: "#000000",
    strokeLinejoin: "round",
    transform: "translate(343.500000, 787.000000) rotate(90.000000) translate(-343.500000, -787.000000) ",
    x: 343,
    y: 628,
    width: 1,
    height: 318
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    strokeWidth: 21,
    cx: 346.5,
    cy: 162.5,
    r: 69
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Path",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    points: "263 340.619089 256.5 400 346 416.674668 436 400 429 340.619089"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M267,279.891135 L426,279.891135 C471.528219,293.335155 496.678164,316.03811 501.449835,348 L503.431599,415.294182 C500.955338,436.441183 487.431007,451.997727 462.858604,461.963814 C391.465318,469.970633 355.768674,473.974043 355.768674,473.974043 L234.338053,462.871867 C215.864081,458.567818 201.345458,443.168752 190.782183,416.674668 L190.510038,344.04883 C199.567782,322.945796 210.073498,307.381071 222.027185,297.354656 C233.980872,287.32824 248.97181,281.507067 267,279.891135 Z",
    id: "Path-2",
    strokeWidth: 24,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348,414.674668 C387.041866,430.88746 388.575953,449.987251 352.602262,471.974043",
    id: "Path-3",
    strokeWidth: 24,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWalkingBehavior);
export default __webpack_public_path__ + "static/media/walking-behavior.167df180b8a21d4961496e3543bace97.svg";
export { ForwardRef as ReactComponent };